var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DropdownMenu',{attrs:{"name":"Status"}},[_c('DropdownMenuItem',{attrs:{"name":"Solved","value":"solved:true"}}),_vm._v(" "),_c('DropdownMenuItem',{attrs:{"name":"Unsolved","value":"solved:false"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }